/**
 * Utilidades para manejo de cookies en el frontend
 */

/**
 * Elimina una cookie del navegador
 * @param name Nombre de la cookie a eliminar
 * @param path Path de la cookie (por defecto '/')
 * @param domain Dominio de la cookie (opcional)
 */
export function deleteCookie(
  name: string,
  path = '/',
  domain?: string,
): void {
  const cookieString = domain
    ? `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain}`
    : `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}`;

  document.cookie = cookieString;
}

/**
 * Elimina una cookie intentando todos los paths y dominios posibles
 * @param name Nombre de la cookie a eliminar
 */
export function forceDeleteCookie(name: string): void {
  const paths = ['/', '/clave-unica', '/api'];
  const hostname = window.location.hostname;
  const domains = [hostname, `.${hostname}`, ''];

  paths.forEach((path) => {
    domains.forEach((domain) => {
      deleteCookie(name, path, domain);
    });
  });
}

/**
 * Obtiene el valor de una cookie
 * @param name Nombre de la cookie
 * @returns Valor de la cookie o null si no existe
 */
export function getCookie(name: string): string | null {
  const nameEQ = name + '=';
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    let c = cookie;
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

/**
 * Establece una cookie
 * @param name Nombre de la cookie
 * @param value Valor de la cookie
 * @param days Días hasta expiración (opcional)
 * @param path Path de la cookie (por defecto '/')
 */
export function setCookie(
  name: string,
  value: string,
  days?: number,
  path = '/',
): void {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=${path}`;
}

/**
 * Limpia todas las cookies del dominio actual
 */
export function clearAllCookies(): void {
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
    forceDeleteCookie(name);
  }
}
